module.exports = __webpack_public_path__ + "static/img/txt-003-kakubesi.6a76236.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/txt-003-kakubesi.svg
// module id = q6K7
// module chunks = 1